// Use dynamic import here to allow webpack to interface with module federation code
//@ts-ignore
import('./bootstrap')
